import { Trans } from '@lingui/macro';
import { Button } from '@pocketlaw/tetris';
import { useGetLinks } from 'shared/domains/urls';
export function ChatButton() {
    const { contact } = useGetLinks();
    return (<Button size="small" $stretch as="a" href={contact} target="_blank" rel="noopener noreferrer">
      <Trans comment="team new-team button upsell dropdown CTA">Get feature</Trans>
    </Button>);
}
